import React, { SyntheticEvent, ChangeEvent } from "react";
import { useSelector } from "react-redux";
import { Button, Container } from "@material-ui/core";
import { useDispatch } from "react-redux";

import { openModalNotificacion } from "../../redux/actions/modalActions";
import { subirArchivos } from "../../redux/actions/operationActions";
import styles from "./styles.styles";
import { agregarArchivos } from "../../redux/actions/tablaActions";
import {
  getContactoPrestador,
  getArchivosAdjuntos,
  getPrestadorEncriptado,
  getArchivosSubidos,
} from "../../redux/selectors";
import { ACCEPT } from "../../consts/constants";

export default () => {
  const dispatch = useDispatch();
  const classes = styles();

  const prestadorEncriptado = useSelector((state) =>
    getPrestadorEncriptado(state)
  );

  const datosPrestador = useSelector((state) => getContactoPrestador(state));
  const archivosAdjuntos = useSelector((state) => getArchivosAdjuntos(state));
  const archivosSubidos = useSelector((state) => getArchivosSubidos(state));

  const controlUpload = (e : SyntheticEvent) => {
    if (!datosPrestador) {
      e.preventDefault();
      dispatch(
        openModalNotificacion({
          open: true,
          missingData: true,
          currDesc: "Para adjuntar los archivos debés completar tus datos",
        })
      );
    }
  };

  const upload = () => {
    const archivosRepetidos = buscarRepetidos(
      archivosAdjuntos,
      archivosSubidos.map((a : File) => a.name),
      "Los siguientes archivos ya se encuentran subidos: \n"
    );
    if(!archivosRepetidos) {
      var fd = new FormData();
      fd.append("prestador", prestadorEncriptado);
      if(datosPrestador.email !== '') fd.append("email", datosPrestador.email);
      if(datosPrestador.telefono !== '') fd.append("telefono", datosPrestador.telefono);
      for (var archivo in archivosAdjuntos)
        fd.append("archivo", archivosAdjuntos[archivo]);
      dispatch(subirArchivos({ fd, archivos: archivosAdjuntos }));
    }
  };

  const add = (files : any) => {
    const archivosRepetidos = buscarRepetidos(
      files,
      archivosAdjuntos.map((a : File) => a.name),
      "Los siguientes archivos ya se encuentran adjuntos: "
    );
    if(!archivosRepetidos) {
      dispatch(agregarArchivos(files));
      (document.getElementById("uploader") as HTMLInputElement).value = '';
    }
  };

  const buscarRepetidos = (unosArchivos : File[], otrosArchivos : string[], msg : string) => {
    let repeatedFiles = [];
    for (let i in unosArchivos) {
      const archivo : File = unosArchivos[i];
      if (otrosArchivos.includes(archivo.name))
        repeatedFiles.push(archivo.name);
    }

    const hayRepetidos = repeatedFiles.length !== 0;
    if (hayRepetidos) 
    dispatch(
      openModalNotificacion({
        open: true,
        currDesc:
          msg +
          repeatedFiles.join(", ")
      })
    );
    return hayRepetidos;
  };

  return (
    <Container disableGutters={true} className={classes.botonera}>
      <input
        accept={ACCEPT}
        className={classes.input}
        id="uploader"
        multiple
        type="file"
        onChange={(e : ChangeEvent<HTMLInputElement>) => add(e.target.files)}
      />
      <label htmlFor="uploader">
        <Button
          color="primary"
          variant="outlined"
          component="span"
          onClick={(e : SyntheticEvent) => controlUpload(e)}
        >
          Adjuntar Archivos
        </Button>
      </label>
      <Button
        style={
          archivosAdjuntos.length === 0
            ? { display: "none" }
            : { display: "flex" }
        }
        color="primary"
        variant="contained"
        component="button"
        onClick={() => upload()}
      >
        Guardar
      </Button>
    </Container>
  );
};
